import React, { useEffect, useState } from "react";
import axios from "axios";
import RazorpayManager from "../components/razorpay/RazorpayManager";

const Settings = () => {
  const [formData, setFormData] = useState({
    siteName: "",
    contactEmail: "",

    privacyPolicyUrl: "",
    termsUrl: "",
    communityGuidelinesUrl: "",
    coinPolicyUrl: "",
    aboutUsUrl: "",

   audioAgoraAppId: "",
audioAgoraAppCertificate: "",

videoAgoraAppId: "",
videoAgoraAppCertificate: "",

    cloudinaryCloudName: "",
    cloudinaryApiKey: "",
    cloudinaryApiSecret: "",

   razorpayKeyId: "",
razorpayKeySecret: "",
WebhookSecret: "",

// Madness
madnessRazorpayKeyId: "",
madnessRazorpayKeySecret: "",
madnessWebhookSecret: "",

    smsApiKey: "",
  });

  const inputStyle =
    "w-full px-3 py-2 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400";

  // ✅ Fetch settings
  const fetchSettings = async () => {
    try {
      const res = await axios.get("/api/v1/admin/site-settings/view-site-settings");

      if (res.data.success && res.data.data) {
        // setFormData({ ...formData, ...res.data.data });
       
        setFormData(prev => ({
  ...prev,
  ...res.data.data
}));

      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // ✅ Handle change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ Save settings
  const saveSettings = async () => {
    try {
      const res = await axios.post(
        "/api/v1/admin/site-settings/add-or-update-site-settings",
        formData
      );

      if (res.data.success) {
        alert("Settings saved successfully!");
      }
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  return (
    <div className="p-6 bg-white min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Site Settings</h1>

      <div className="space-y-6">

        {/* GENERAL */}
        <Section title="General">
          

          <Field label="Contact Email">
            <input name="contactEmail" value={formData.contactEmail}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* LINKS */}
        <Section title="Policy Links">
          <Field label="Privacy Policy URL">
            <input name="privacyPolicyUrl" value={formData.privacyPolicyUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Terms & Conditions URL">
            <input name="termsUrl" value={formData.termsUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Community Guidelines URL">
            <input name="communityGuidelinesUrl"
              value={formData.communityGuidelinesUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Coin Policy URL">
            <input name="coinPolicyUrl" value={formData.coinPolicyUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="About Us URL">
            <input name="aboutUsUrl" value={formData.aboutUsUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* AGORA */}
       <Section title="Audio Agora">

  <Field label="Audio App ID">
    <input
      name="audioAgoraAppId"
      value={formData.audioAgoraAppId}
      onChange={handleChange}
      className={inputStyle}
    />
  </Field>

  <Field label="Audio Certificate">
    <input
      name="audioAgoraAppCertificate"
      value={formData.audioAgoraAppCertificate}
      onChange={handleChange}
      className={inputStyle}
    />
  </Field>

</Section>

<Section title="Video Agora">

  <Field label="Video App ID">
    <input
      name="videoAgoraAppId"
      value={formData.videoAgoraAppId}
      onChange={handleChange}
      className={inputStyle}
    />
  </Field>

  <Field label="Video Certificate">
    <input
      name="videoAgoraAppCertificate"
      value={formData.videoAgoraAppCertificate}
      onChange={handleChange}
      className={inputStyle}
    />
  </Field>

</Section>

        {/* CLOUDINARY */}
        <Section title="Cloudinary">
          <Field label="Cloud Name">
            <input name="cloudinaryCloudName"
              value={formData.cloudinaryCloudName}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="API Key">
            <input name="cloudinaryApiKey"
              value={formData.cloudinaryApiKey}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="API Secret">
            <input  name="cloudinaryApiSecret"
              value={formData.cloudinaryApiSecret}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* RAZORPAY */}
        {/* <Section title="Razorpay">
          <Field label="Key ID">
            <input name="razorpayKeyId"
              value={formData.razorpayKeyId}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Key Secret">
            <input type="password" name="razorpayKeySecret"
              value={formData.razorpayKeySecret}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section> */}

{/* ======================= PAYMENT GATEWAYS ======================= */}

<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

  {/* Pookie + Lovely */}
  <div className="rounded-xl border border-pink-200 shadow-sm bg-pink-50">

    <div className="px-5 py-4 border-b bg-pink-600 rounded-t-xl">
      <h2 className="text-lg font-semibold text-white">
        💳 Pookie 
      </h2>

      <p className="text-pink-100 text-sm mt-1">
        These credentials are shared by both Pookie applications.
      </p>
    </div>

    <div className="p-5 space-y-4">

      <Field label="Key ID">
        <input
          name="razorpayKeyId"
          value={formData.razorpayKeyId}
          onChange={handleChange}
          className={inputStyle}
        />
      </Field>

      <Field label="Key Secret">
        <input
          type="password"
          name="razorpayKeySecret"
          value={formData.razorpayKeySecret}
          onChange={handleChange}
          className={inputStyle}
        />
      </Field>

      <Field label="Webhook Secret">
        <input
          name="WebhookSecret"
          value={formData.WebhookSecret}
          onChange={handleChange}
          className={inputStyle}
        />
      </Field>

    </div>

  </div>

  {/* Madness */}

  <div className="rounded-xl border border-yellow-300 shadow-sm bg-yellow-50">

    <div className="px-5 py-4 border-b bg-yellow-500 rounded-t-xl">
      <h2 className="text-lg font-semibold text-white">
        ⚡ Madness Razorpay
      </h2>

      <p className="text-yellow-100 text-sm mt-1">
        These credentials are used only by the Madness application.
      </p>
    </div>

    <div className="p-5 space-y-4">

      <Field label="Key ID">
        <input
          name="madnessRazorpayKeyId"
          value={formData.madnessRazorpayKeyId}
          onChange={handleChange}
          className={inputStyle}
        />
      </Field>

      <Field label="Key Secret">
        <input
          type="password"
          name="madnessRazorpayKeySecret"
          value={formData.madnessRazorpayKeySecret}
          onChange={handleChange}
          className={inputStyle}
        />
      </Field>

      <Field label="Webhook Secret">
        <input
          name="madnessWebhookSecret"
          value={formData.madnessWebhookSecret}
          onChange={handleChange}
          className={inputStyle}
        />
      </Field>

    </div>

  </div>

</div>


        {/* SMS */}
        <Section title="SMS">
          <Field label="SMS API Key">
            <input name="smsApiKey"
              value={formData.smsApiKey}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        <button
          onClick={saveSettings}
          className="bg-pink-700 px-6 py-3 rounded-lg font-semibold w-full"
        >
          Save Settings
        </button>

      </div>
      {/* <RazorpayManager/> */}
    </div>
  );
};

// ✅ Reusable Components
const Section = ({ title, children }) => (
  <div className="border p-4 rounded-lg space-y-4">
    <h2 className="font-semibold text-lg">{title}</h2>
    {children}
  </div>
);

const Field = ({ label, children }) => (
  <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    {children}
  </div>
);

export default Settings;
